export const getCompanyChallenges = (state) => state.challenges.companyChallenges;